module.exports = __webpack_public_path__ + "img/alert-preview.22eda0c8.png";